module.exports = __webpack_public_path__ + "media/images/members/block-78f4eed08a1a0abfa7e3d62335e8048a.png";